export const typeOfInsuranceAttributes: string[] = [
    'automobilesCovered',
    'occurrenceOrClaimsMade',
    'generalAggregateLimitAppliesPer',
    'limits',
    'policyType',
];
